import {defineCustomElement} from 'extensions/utils';
import {html, LitElement, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import styles from './x-carousel-image-card.component.scss?as=stylesheet';

export class CarouselImageCard extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			bgImage: {
				attribute: 'bg-image',
				type: String
			},
			bgImageAlt: {
				attribute: 'bg-image-alt',
				type: String
			},
			caption: {
				type: String
			},
			captionImage: {
				attribute: 'caption-image',
				type: String
			},
			doNotForceImageSize: {
				attribute: 'do-not-force-image-size',
				type: Boolean
			},
			flag: {
				type: String
			},

			link: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.flag = '';
	}

	render () {
		const rootClasses = {
			container: true,
			'image-size--regular': this.doNotForceImageSize,
			'layout--image': this.captionImage
		};

		return html`
			<a href="${this.link}" class="${classMap(rootClasses)}">
				${this.flag ? html`<div class="flag">${this.flag}</div>` : nothing}
				<figure>
					<img class="bg-img" src="${this.bgImage}" alt="${this.bgImageAlt}" loading="lazy" />
					<figcaption>
						${this.captionImage ? html`<img class="caption-image" src="${this.captionImage}" loading="lazy" alt="${this.caption}" />` : html`<span class="caption">${this.caption}</span>`}
					</figcaption>
				</figure>
			</a>
		`;
	}
};

defineCustomElement('x-carousel-image-card', CarouselImageCard);
